export const skillDomains = [
  { id: 'cognitive', label: 'Cognitive / Academic Skills' },
  { id: 'fineMotor', label: 'Fine Motor Skills (writing, cutting, gripping)' },
  { id: 'grossMotor', label: 'Gross Motor Skills (balancing, catching, walking)' },
  { id: 'receptiveLang', label: 'Receptive Language (understanding instructions)' },
  { id: 'expressiveLang', label: 'Expressive Language / Communication (verbal, AAC, signing)' },
  { id: 'socialEmotional', label: 'Social-Emotional / Interpersonal Skills' },
  { id: 'adls', label: 'Adaptive / Daily Living Skills — ADLs (feeding, toileting, dressing)' },
  { id: 'sensoryRegulation', label: 'Sensory Regulation' },
];

export const learningStyles = [
  { id: 'visual', label: 'Visual (Pictures, schedules, video modeling)' },
  { id: 'auditory', label: 'Auditory (Songs, verbal patterns, rhythmic prompts)' },
  { id: 'tactile', label: 'Tactile / Kinesthetic (Hands-on objects, movement-based tasks)' },
  { id: 'sensorySpecific', label: 'Sensory-Specific (Weighted vests, dim lighting, quiet corners)' },
];

export const standardTLMMaterials = [
  'Flashcards',
  'Adaptive scissors',
  'Sand tray',
  'Communication board (AAC)',
  'Blocks / Manipulatives',
  'Picture schedule cards',
  'Weighted vest / lap pad',
  'Noise-cancelling headphones',
  'Slant board',
  'Pencil grips',
  'Therapy putty',
  'Social story booklet',
  'Timer (visual / sand)',
  'Sensory bin',
  'Velcro strips / Adaptive fasteners',
];

export const promptHierarchyLevels = [
  { value: 'fullPhysical', label: 'Full Physical' },
  { value: 'partialPhysical', label: 'Partial Physical' },
  { value: 'verbal', label: 'Verbal' },
  { value: 'visual', label: 'Visual' },
  { value: 'independent', label: 'Independent' },
];

export const measurementCriteriaOptions = [
  { value: 'frequency', label: 'Frequency Count' },
  { value: 'duration', label: 'Duration' },
  { value: 'percentage', label: 'Percentage' },
  { value: 'trialByTrial', label: 'Trial-by-Trial' },
];